import { PropsWithChildren, useContext } from 'react';
import styled from '@emotion/styled';
import { Card, CardContent, Fade, Grid, Typography } from '@mui/material';

import { ConfigContext } from '@/contextAPI/configContext';
import { useAppSelector } from '@/redux/hooks';
import { selectTitleLoading, selectFilteredActiveTitle } from '@/redux/selectors/titleSelectors';
import { selectIsActiveTitleLoading, selectActiveTitle } from '@/redux/selectors/titleV2Selectors';
import { Spinner } from '@/components/_common';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import OPTitleSearch from '@/components/OrderPlacement/OPTitleSearch/OPTitleSearch';
import OPViewingTitleHeader from '@/components/OrderPlacement/OPStep2FileSelection/OPViewingTitleHeader';
import { selectBulkTitleLoading, selectBulkTitles } from '@/redux/selectors/bulkSearchSelectors';

const BulkTitleSearch = ({ children }: PropsWithChildren) => {
  const bulkSearchTitles = useAppSelector(selectBulkTitles);
  const bulkTitlesLoading = useAppSelector(selectBulkTitleLoading);
  const isTitleV2 = useContext(ConfigContext)?.titleConfig?.v2;
  const isLoading = isTitleV2 ? useAppSelector(selectIsActiveTitleLoading) : useAppSelector(selectTitleLoading);
  const activeTitle = isTitleV2 ? useAppSelector(selectActiveTitle) : useAppSelector(selectFilteredActiveTitle);

  return (
    <Fade in timeout={400}>
      <Grid xs={12} md={7} item position="relative">
        <OPTitleSearch showBulkSearchButton />
        {!isLoading && <OPViewingTitleHeader />}
        {!bulkSearchTitles.length && !activeTitle ? (
          <PlaceholderCard elevation={0}>
            <CardContent>
              <Grid container flexDirection="column" alignItems="center" justifyContent="center" minHeight={155} my={2}>
                {bulkTitlesLoading || isLoading ? (
                  <Grid item pt={6}>
                    <Spinner contained />
                    <Typography variant="subtitle2" sx={{ mt: 3, opacity: 0.8 }} align="center">
                      Loading Title{bulkTitlesLoading ? 's' : ''}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item sx={{ opacity: 0.1 }}>
                    <PolarisIcon icon="movie_search" width="100" height="100" />
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </PlaceholderCard>
        ) : (
          children
        )}
      </Grid>
    </Fade>
  );
};

export default BulkTitleSearch;

const PlaceholderCard = styled(Card)(() => ({
  overflow: 'visible',
  position: 'relative'
}));
